import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import { v4 as uuid } from "uuid";
import { useFormik } from "formik";
import ReactSelect from "../../UI/ReactSelect";
import * as Yup from "yup";
import axios from "axios";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import InputMask from "react-input-mask";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
const initialValues = {
  assetId: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  password: "",
  confirmPassword: "",

};

export default function Create(props) {
  const {
    show,
    onHide,
    onHumanResources,
    skip,
    take,
    sortField,
    orderBy,
    assets,
  } = props;
  const [isError, setIsError] = useState("");

  const [values, setValues] = useState({
    password: "",
    confirmPassword: "",
    showPassword: false,
    showRePassword: false,
  });
  const handleClickShowPassword = (key) => {
    setValues({ ...values, [key]: !values[key] });
  };



  const CreateSchema = Yup.object().shape({
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    email: Yup.string().required("Email is required")
    .email("Wrong email format. E.g. jhon.doe@example.com")
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    ,
    phone: Yup.string().required("Phone is required"),
    password: Yup.string()
      .matches(
        /^(?=.*[a-z])(?=.*[0-9])(?=.{8,})/,
        "Password must consist of a letter, a number."
      )
      .required("Password is required"),
    confirmPassword: Yup.string()
      .when("password", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          "Both password need to be the same"
        ),
      })
      .matches(
        /^(?=.*[a-z])(?=.*[0-9])(?=.{8,})/,
        "Password must consist of a letter, a number."
      )
      .required("Confirm Password is required"),
  });

  const [phone, setPhone] = React.useState("");
  // function handleChangePhoneNumber(e) {
  //   setPhone(e.target.value);
  // }



  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };

  const [assetsOption, setAssetsOption] = React.useState(null);
  function handleChangeAssets(value) {
    setAssetsOption(value);
  }

  const onPostHumanResource = (values, resetForm, setSubmitting) => {
    const humanResource = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      // phone: values.phone,
      phone: values.phone,
      password: values.password,
      assetId: assetsOption.value,
    };
    axios
      .post(`${process.env.REACT_APP_API_URL}humanResource`, humanResource, {
        headers: {
          "x-requestid": uuid(),
        },
      })
      .then((res) => {
        onHumanResources(skip, take, sortField, orderBy);
        setSubmitting(false);
        resetForm();
        onHide();
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        }
      );
  };

  const formik = useFormik({
    initialValues,
    validationSchema: CreateSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPostHumanResource(values, resetForm, setSubmitting);
    },
  });

  const assetsOptions = assets.map((suggestion) => ({
    value: suggestion.id,
    label: suggestion.name,
  }));

  useEffect(() => {
    setIsError("");
    setPhone("");
    if (!show) {
      setAssetsOption("")
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="sm"
      aria-labelledby="edit"
      centered
      className="modal-right pr-0"
    >
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="edit">Create</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 col-md-12 col-lg-12">
            <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
              <TextField
                id="assetId"
                name="assetId"
                label="Asset id"
                placeholder="Asset id"
                className="w-100"
                type="number"
                hidden
                error={getInputClasses("assetId")}
                {...formik.getFieldProps("assetId")}
              />

              <ReactSelect
                suggestions={assetsOptions}
                handleChangeSingle={handleChangeAssets}
                single={assetsOption}
                label="Choose asset"
                placeholder="Choose asset"
                inputId="assetId"
                error={getInputClasses("assetId")}
                {...formik.getFieldProps("assetId")}
              />
            </div>
            {formik.touched.assetId && formik.errors.assetId ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.assetId}</div>
              </div>
            ) : null}
          </div>

          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="firstName"
                    label="First Name"
                    placeholder="First Name"
                    className="w-100"
                    error={getInputClasses("firstName")}
                    {...formik.getFieldProps("firstName")}
                  />
                </div>
                {formik.touched.firstName && formik.errors.firstName ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.firstName}
                    </div>
                  </div>
                ) : null}
              </div>

              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="lastName"
                    label="Last Name"
                    placeholder="Last Name"
                    className="w-100"
                    error={getInputClasses("lastName")}
                    {...formik.getFieldProps("lastName")}
                  />
                </div>
                {formik.touched.lastName && formik.errors.lastName ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.lastName}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="email"
                    label="Email"
                    placeholder="Email"
                    className="w-100"
                    error={getInputClasses("email")}
                    {...formik.getFieldProps("email")}
                  />
                </div>
                {formik.touched.email && formik.errors.email ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.email}</div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  {/* <TextField
                    id="phone"
                    label="Phone"
                    placeholder="Phone"
                    className="w-100"
                    error={getInputClasses("phone")}
                    {...formik.getFieldProps("phone")}
                  /> */}
                  <InputMask
                    mask="\9\94999999999"
                    // value={phoneNumber}
                    {...formik.getFieldProps("phone")}

                    // onChange={(e) => handleChangePhoneNumber(e)}
                    disabled={false}
                    maskChar=""
                    id="phone"
                    type="number"

                  >
                    {() =>
                      <TextField
                        label="Phone"
                        name="phone"
                        placeholder="Phone"
                        className="w-100"
                        error={getInputClasses("phone")}

                      // error={getInputClasses("phone")}
                      // {...formik.getFieldProps("phone")}
                      />}
                  </InputMask>
                </div>
                {formik.touched.phone && formik.errors.phone ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.phone}</div>
                  </div>
                ) : null}
              </div>


              <div className="d-none">{phone}</div>


              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="password"
                    className="w-100"
                    type={values.showPassword ? "text" : "password"}
                    label="Password"
                    error={getInputClasses("password")}
                    {...formik.getFieldProps("password")}
                    autoComplete="off"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            aria-label="Toggle password visibility"
                            onClick={() =>
                              handleClickShowPassword("showPassword")
                            }
                          >
                            {values.showPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                {formik.touched.password && formik.errors.password ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.password}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="confirmPassword"
                    className="w-100"
                    type={values.showRePassword ? "text" : "password"}
                    label="Confirm password"
                    error={getInputClasses("confirmPassword")}
                    {...formik.getFieldProps("confirmPassword")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            aria-label="Toggle password visibility"
                            onClick={() =>
                              handleClickShowPassword("showRePassword")
                            }
                          >
                            {values.showRePassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                {formik.touched.confirmPassword &&
                  formik.errors.confirmPassword ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.confirmPassword}
                    </div>
                  </div>
                ) : null}
                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => onHide(false)}>
            Close
          </Button>
          <Button type="submit">Create</Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
